export const inspectData_1 = [
  {
    label: "관리책임자의 현장 배치 적정성",
    is_checked: "",
  },
  {
    label: "품질관리자의 현장 배치 적정성",
    is_checked: "",
  },
  {
    label: "안전관리자의 현장 배치 적정성",
    is_checked: "",
  },
];

export const inspectData_2 = [
  {
    label: "품질관리계획 또는 품질시험계획 수립여부",
    is_checked: "",
  },
  {
    label: "품질시험 이행상태(실적)",
    is_checked: "",
  },
  {
    label: "시험장비 및 검교정 현황",
    is_checked: "",
  },
  {
    label: "철근·철골 사용의 적정성<br />- 한국산업표준에 정한 기준(KS) 이상의 자재 사용여부 (불량 중국산 자재 사용여부 확인)<br />- 품질시험여부 및 그 결과",
    is_checked: "",
  },
];

export const inspectData_3 = [
  {
    label: "한중 콘크리트 타설계획 수립 및 적정성 여부",
    is_checked: "",
  },
  {
    label:
      "콘크리트 타설시 작업방법의 적정성<br />- 타설 전 거푸집동바리 변형, 변위 및 지반의 침하 유무<br />- 타설 전 타설순서, 타설방법, 타설인원 등 타설 계획 수립여부<br />- 타설 시 한 곳에 집중 타설 금지 준수 여부<br />- 동절기 콘크리트 동해방지를 위한 보온·보양조치(계획)의 적정성",
    is_checked: "",
  },
  {
    label: "보온·보양 시설 상태 점검<br />- 기능·성능상 적정 여부<br />- 화재·가스사고 방지대책 이행여부 및 적정성",
    is_checked: "",
  },
];

export const inspectData_4 = [
  {
    label: "한파 관련 근로자 건강관리<br />- 옥외작업 최소화 및 한랭질환 예방교육 실시",
    is_checked: "",
  },
  {
    label: "염화칼슘, 모래, 부직포 등의 장비확보<br />- 여유분 확보 및 자재관리방안",
    is_checked: "",
  },
  {
    label: ["광범위한 비상연락망 구축<br />- 발주처, 소방서, 병원 등 유관기관 포함", "현장 비상대기반 편성·운영<br />- 폭설 등 비상사태 시 비상대기반 24시간 운영"],
    is_checked: "",
  },
  {
    label: "비상사태 발생시 대책수립 여부<br />- 근로자 대피계획, 장비 및 자재보호계획 등",
    is_checked: "",
  },
];

export const inspectData_5 = [
  {
    label: "공사용 가설도로 상태의 적정성<br />- 노면의 폭 및 요철부분 정비<br />- 일정간격 모래함, 염화칼슘함 비치<br />- 동결·융해 반복 시 단부 휀스 설치상태 점검",
    is_checked: "",
  },
  {
    label: "지하매설물 보호조치의 적정성<br />- 노출 상·하수도 관로, 제수변 및 분기개소에 보온 조치 여부<br />- 매설물의 노출부에 노면수 유입방지를 위한 조치 여부<br />- 배관 등 지하매설물 근접 굴착시 안전조치 준수 여부",
    is_checked: "",
  },
];

export const inspectData_6 = [
  {
    label: "안전통로 확보여부<br />- 안전통로 확보 및 사용상태 유지 여부<br />- 통로 주변 안전표지 등 통로 표시 상태",
    is_checked: "",
  },
  {
    label: "비계 상 추락방지<br />- 작업발판 구조 및 안전난간 설치 상태<br />- 추락방호망 설치 상태",
    is_checked: "",
  },
  {
    label: "철골작업시 추락방지<br />- 승강로 설치 상태<br />- 추락방호망 및 안전대 부착설비 설치 상태<br />- 안전대 및 부속설비 이상유무 확인",
    is_checked: "",
  },
  {
    label: "지붕작업시 추락방지<br />- 폭 30cm이상 작업발판 설치 상태<br />- 하부 추락방호망 설치 상태<br />- 지붕단부 안전난간 설치 유무",
    is_checked: "",
  },
  {
    label: "개구부 상의 추락방지<br />- 안전난간, 울타리, 덮개 등 방호조치 설치 상태<br />- 임시로 안전난간 등 해체시 추락방호망 및 안전대 부착설비 설치상태",
    is_checked: "",
  },
  {
    label: "폭설 시 가시설 설치상태의 안전성<br />- 외부 낙하물방지망, 방호선반 위 제설 여부<br />- 폭설에 의한 붕괴위험 지역 출입통제 여부",
    is_checked: "",
  },
];

export const inspectData_7 = [
  {
    label:
      "굴착사면 지반상태의 적정성<br />- 사면 구배의 적정성 여부<br />- 동결에 따른 지반팽장으로 절리, 균열부위 발생 등 사면상태의 이상유무<br />- 토석의 붕괴, 낙반위험에 대한 조치 여부<br />- 비탈상부 노면수 유입 방지시설 설치 여부(배수로 측구, 사면 천막비닐 설치 등)",
    is_checked: "",
  },
  {
    title: "시공상태 확인",

    label:
      "흙막이 지보공 설치상태의 적정성<br />- 조립도 작성 및 작업순서 준수 여부<br />- 재료의 적정성 및 이음, 접합부위 이상 유무<br />- 부재의 손상, 변형, 부식, 변위, 탈락유무<br />- 수평버팀대 좌굴방지 등의 조치 이상 유무<br />- 배면토사 충진 및 노면수 유입방지조치 여부",
    is_checked: "",
  },
  {
    title: "시공상태 확인",

    label: "거푸집 동바리 설치상태의 적정성<br />- 거푸집 동바리 재료의 적정성(불량, 미검정품 사용)<br />- 구조검토에 의한 조립도 작성 및 준수여부<br />- 거푸집 동바리 설치시 안전기준 준수여부",
    is_checked: "",
  },
];

export const inspectData_8 = [
  {
    label: "밀폐공간 작업시 특별안전교육 실시<br />- 맨홀작업, 산소결핍장소에서의 작업, 페인트·본드 등 유기용제의 취급 작업 시 관리감독자를 지정하고, 특별안전보건교육 실시 여부",
    is_checked: "",
  },
  {
    title: "시공상태 확인",

    label:
      "가설숙소, 현장사무실 및 창고 등의 난방기구 배치 및 전열기 상태의 적정성<br />- 난방기구 주변 유류 및 가연성물질 방치 여부<br />- 화기주변 및 출입구 주위에 소화기, 방화사 등 진화장비 비치 여부<br />- 전기기계․기구의 누전차단기 경유 사용 여부",
    is_checked: "",
  },
  {
    title: "시공상태 확인",

    label: "밀폐공간 내 환기시설 설치 및 정상 작동여부<br />- 가설숙소<br />- 지하정화조, 저수조, 맨홀, 지하주차장 등",
    is_checked: "",
  },
  {
    label: "밀폐공간 내 작업시 안전기준 준수여부<br />- 산소농도 측정 및 환기실시 여부<br />- 유기용제 사용작업장 주변 담배, 모닥불 등 화기 사용금지 여부<br />- 작업장소 출입 시 호흡용 보호구 착용 여부",
    is_checked: "",
  },
  {
    label: "산소결핍 우려지역 작업 시에는 송기마스크, 공기호흡기, 산소호흡기 등 호흡용 보호구 착용 여부",
    is_checked: "",
  },
  {
    label: "사고발생 등 긴급사태 발생 시 근로자의 피난, 구출 등을 위한 사다리 및 섬유로프 등 비치 여부",
    is_checked: "",
  },
];

export const inspectData_9 = [
  {
    label: "화기작업시 특별안전교육 실시<br />- 용접·용단 또는 가열하는 작업시 특별안전보건교육 실시 여부<br />- 밀폐된 장소에서 하는 용접작업 또는 습한 장소에서 하는 전기용접 작업시 특별안전보건교육 실시 여부",
    is_checked: "",
  },
  {
    label: "위험물질 관리상태의 적정성<br />- 용접작업 주변 신나, 방수제, 유류 등 인화성, 발화성 물질 방치여부<br />- 위험물질 보관저장소의 위치, 상태 등의 적정성 여부",
    is_checked: "",
  },
  {
    label: "위험물이 있는 장소에서 화기 사용 여부<br />- 화재 또는 폭발이 발생할 우려가 있는 장소 또는 그 상부에서 불꽃이나 아크를 발생하거나 고온으로 될 우려가 있는 기계·기구·공구 사용 금지",
    is_checked: "",
  },
  {
    label: "재위험작업의 준수사항 이행 및 서면게시, 화재감시자의 배치 여부<br />- 화재위험 작업을 하는 경우 화재위험을 감시하고 화재발생시 근로자 대피를 유도하는 화재감시자를 지정하여 배치",
    is_checked: "",
  },
];

export const inspectData_10 = [
  {
    label: "작업전 T.B.M(Tool Box Meeting) 실시여부<br />- 작업전 충분한 체조 등으로 경직된 근육이완<br />- 동상방지를 위한 장갑, 귀마개 등 보온장구 착용 여부",
    is_checked: "",
  },
  {
    label: "장시간 외기 노출시 동상 발생방지를 위한 손, 발, 귀 등 마사지 실시여부<br />- 습기가 있는 장갑, 안전화 등 착용금지",
    is_checked: "",
  },
  {
    label: "기온하강에 따른 뇌․심혈관질환 예방조치 여부<br />- 충분한 휴식, 방한복 지급, 따뜻한 음료 제공 등",
    is_checked: "",
  },
  {
    label: "기타 근로자 건강관리를 위한 예방조치 실시 여부",
    is_checked: "",
  },
];
